export default {
  apiKey: "AIzaSyAPpe4y9O1J_q6_Jako761gQd6j9hGKhn4",
  authDomain: "pili-mobile.firebaseapp.com",
  databaseURL: "https://pili-mobile.firebaseio.com",
  projectId: "pili-mobile",
  storageBucket: "pili-mobile.appspot.com",
  messagingSenderId: "450792315501",
  appId: "1:450792315501:web:0a755b9fa57f7916"
};
